// Read-only scoring and financial display; all market settlement outcomes come from the existing API settler.
export function equivalentHitExpectation(tip) {
 return Number.isFinite(tip.fairOdd)&&tip.fairOdd>=1?1/tip.fairOdd:null;
}
export function proposalResults(tips,evaluation,mode='fixed',amount=1) {
 const byId=new Map((evaluation?.rows||[]).map(r=>[r.id,r]));
 return tips.map(t=>{
  const r=byId.get(t.id),valid=Number.isFinite(amount)&&amount>0&&Number.isFinite(t.marketOdd)&&t.marketOdd>1;
  const stake=valid?(mode==='swing'?amount/t.marketOdd:amount):null;
  const profit=r?.settlement&&stake!==null?r.settlement.units*stake:null;
  return {...t,result:r?.result||null,virtual:true,virtualCurrency:mode==='swing'?'€':'u',virtualStatus:r?.status||'unavailable',virtualReason:r?.reason,
   equivalentExpected:equivalentHitExpectation(t),
   actualHits:r?.status==='settled'?({win:1,'half-win':0.75,push:0.5,'half-loss':0.25,loss:0})[r.settlement?.outcome]??null:null,
   virtualStake:stake,virtualReturn:profit===null?null:stake+profit,
   settlement:r?.settlement?{...r.settlement,profit}:null};
 });
}
export function proposalSummary(rows) {
 const settled=rows.filter(r=>r.virtualStatus==='settled'),priced=settled.filter(r=>Number.isFinite(r.settlement?.profit));
 // Equivalent hit expectation is the user's scoring definition, not full-win probability.
 const comparable=settled.filter(r=>Number.isFinite(r.equivalentExpected));
 const stake=priced.reduce((s,r)=>s+r.virtualStake,0),returns=priced.reduce((s,r)=>s+r.virtualReturn,0);
 const expected=comparable.length?comparable.reduce((s,r)=>s+r.equivalentExpected,0):null;
 const actual=settled.length?settled.reduce((s,r)=>s+r.actualHits,0):null;
 const complete=settled.length>0&&comparable.length===settled.length;
 return {total:rows.length,settled:settled.length,open:rows.filter(r=>r.virtualStatus==='open').length,
  unavailable:rows.filter(r=>r.virtualStatus==='unavailable').length,final:rows.length>0&&settled.length===rows.length,
  counts:Object.fromEntries(['win','half-win','loss','half-loss','push'].map(k=>[k,settled.filter(r=>r.settlement?.outcome===k).length])),
  expected,actual,difference:complete?actual-expected:null,expectedRate:complete?expected/settled.length:null,actualRate:settled.length?actual/settled.length:null,probabilityCoverage:comparable.length,
  financialCoverage:priced.length,stake,returns,profit:returns-stake,roi:stake?100*(returns-stake)/stake:null,
  pendingStake:rows.filter(r=>r.virtualStatus!=='settled').reduce((s,r)=>s+(r.virtualStake||0),0)};
}
